export default {
delivery_management: "Driver Allocation",
delivery_subtitle: "Manage delivery staff information",
add_update_delivery: "Add / Update Delivery Boy",

driver_name: "Driver Name",
enter_driver_name: "Enter Driver Name",

mobile_number: "Mobile Number",
enter_mobile: "Enter Mobile Number",

vehicle_type: "Vehicle Type",
vehicle_type_placeholder: "Bike / Van",

vehicle_number: "Vehicle Number",
enter_vehicle_number: "Enter Vehicle Number",

submit_delivery: "Submit Delivery Boy",
update_delivery: "Update Delivery Boy",
delete_delivery: "Delete Delivery Boy",

select_delivery: "Select Saved Delivery Boy",
select_delivery_placeholder: "-- Select Delivery Boy --",

delivery_required: "⚠️ Name and Mobile are required",
delivery_saved: "✅ Delivery Boy Saved Successfully",
delivery_updated: "✅ Delivery Boy Updated Successfully",
delivery_deleted: "❌ Delivery Boy Deleted Successfully",

delete_confirm: "Are you sure you want to delete this delivery boy?",
server_error: "❌ Server Error",
failed: "Failed",
}